export const RequestOptions = (token, method, body) => ({
    method,
    headers: new Headers({
        'accept': 'application/json',
        'Content-Type': 'application/json',//application/json
        'Authorization': "Bearer " + token
    }),
    body: body ? JSON.stringify(body) : undefined
})
